import { Layout, Row, Table } from 'antd';
import Column from 'antd/lib/table/Column';
import React from 'react';
import UserSideNav from './UserSideNav';

const { Header, Content, Sider } = Layout;

const UserLayout: React.FC<React.PropsWithChildren> = (props) => {
  return (
    <Layout className='user-layout'>
      <Sider
        className='cider'
        defaultCollapsed
      >
        <UserSideNav />
      </Sider>

      <Layout className='content-layout'>
        <Header className="top-header">
          <span className='intro-text' style={{fontSize: '20px'}}>Support Dashboard</span>
        </Header>

        <Content className='content-container'>
          {props.children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default UserLayout;
